export { default } from './TrendIndicator';
export { TrendIndicatorProps } from './TrendIndicator.types';
